import { Box, styled, TyreSizeTable } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { Tyre, TyreSelection } from "@bundles/tyres/data/models"
import { ETyresSeason } from "@tm/models"
import { useState } from "react"
import { SummaryAccordionTitle } from "../../_shared/SummaryAccordionTitle"

type Props = {
    tyreList: Tyre[]
    sameSize: boolean
    handleTyreSelect: (tyreItem: Tyre, season?: ETyresSeason) => void
    handleVariantSelect?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, tyreItem: Tyre, selection: TyreSelection) => void
}
export function TyreListAccordion({ tyreList, sameSize, handleTyreSelect, handleVariantSelect }: Props) {
    const { translateText } = useLocalization()
    const [open, setOpen] = useState(true)
    const scrollable = sameSize ? tyreList.length > 4 : tyreList.length > 3

    const onTitleClick = () => {
        setOpen((prev) => !prev)
    }

    return (
        <StyledBox open={open} scrollable={scrollable}>
            <SummaryAccordionTitle
                title={translateText(sameSize ? 240 : 13913)}
                subtitle={translateText(sameSize ? 13923 : 13924)}
                onClick={onTitleClick}
                open={open}
            />
            {open && (
                <TyreSizeTable
                    tyreList={tyreList}
                    sameSize={sameSize}
                    handleTyreSelect={handleTyreSelect}
                    handleVariantSelect={handleVariantSelect}
                    scrollable={scrollable}
                />
            )}
        </StyledBox>
    )
}

const StyledBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== "open" && prop !== "scrollable",
})<{ open: boolean; scrollable: boolean }>(({ open, scrollable }) => ({
    flex: open ? (scrollable ? "1 1 80%" : "0 1 auto") : "0 0 auto",
    margin: "0 4.5em",
    position: "relative",
    "& .Table-scrollContainer": {
        position: scrollable && "absolute",
        marginLeft: "2em",
        width: "95%",
        "&::-webkit-scrollbar": {
            backgroundColor: "transparent",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
        },
    },
}))
